// Path: ./src/hooks/useMerchants.ts
import { useState, useEffect, useCallback, useContext } from "react";
import { adminApiService } from "../utils/api";
import { GfMerchant } from "@swagger/typescript-fetch-goflyer";
import { debounce } from "../utils/debounce";
import { SUPERADMIN } from "../utils/constant/stringConstant";
import { GoFlyerAdminContext } from "../contextApi/context";

export const useMerchants = () => {
  const [merchantsList, setMerchantsList] = useState<GfMerchant[]>(); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) maybe we should do the mapping here to create label
  const [isMerchantOptionLoading, setIsMerchantOptionLoading] = useState(false);
  const { state } = useContext(GoFlyerAdminContext);

  const fetchMerchants = useCallback(async () => {
    try {
      const conditions = [];
      const merchantList =
        state.user?.parsedRoles?.name === SUPERADMIN
          ? []
          : state.user?.merchant?.map((value) => {
              return `${value.id}`;
            }) || [];

      if (merchantList && merchantList.length) {
        conditions.push(`id||$in||${merchantList?.join(",")}`);
      }

      const merchants =
        await adminApiService.getManyBaseGfMerchantAdminControllerGfMerchant(
          undefined,
          undefined,
          conditions?.length ? conditions : undefined,
          undefined,
          undefined,
          undefined,
          100,
          0,
          1,
          undefined
        );

      setMerchantsList(merchants.data);
    } catch (error) {
      console.error("Error fetching merchants:", error);
    }
  }, []);

  const handleOnMerchantSearch = useCallback(
    debounce(async (value: string) => {
      if (
        state.user?.merchant?.length &&
        state.user?.parsedRoles?.name !== SUPERADMIN
      ) {
        return;
      }
      if (value === "") {
        return;
      }
      setIsMerchantOptionLoading(true);
      //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) you can't search if for other role?
      const searchTextValue = value.trim().toLowerCase();
      const response = await adminApiService.gfMerchantAdminControllerSearch(
        `${searchTextValue}`,
        1 as number,
        100 as number
      );

      //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) will improve this logic. not sure why we need const uniqueMap = new Map(); logic previously
      setMerchantsList(response.data);

      setIsMerchantOptionLoading(false);
    }, 500),
    []
  );

  useEffect(() => {
    fetchMerchants();
  }, []);

  return {
    merchantsList,
    isMerchantOptionLoading,
    fetchMerchants,
    handleOnMerchantSearch,
  };
};
